import Constants from "../Constants";

export class PatientEnrollmentConstant {
  static POSTAL_API_URL = Constants.POSTAL_SERVICE_API_ENDPOINT;
}
